import { render } from "./DocumentsOrganisationAdministrative.vue?vue&type=template&id=be9582f2"
import script from "./DocumentsOrganisationAdministrative.vue?vue&type=script&lang=js"
export * from "./DocumentsOrganisationAdministrative.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__